import React from "react";
import { connect } from "react-redux";
import { get, update } from "./Reducers/actions";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
class GeruikersPage extends React.Component {
  state = {
    errors: {},
    deelnemers: 0,
    hulpkrachten: 0,
    recreatieleider: 0,
    stagiaires: 0,
    openDropdowns: {}, // Track which dropdowns are open
    buttonPositions: {}, // Track button positions for dropdown positioning
  };

  componentWillMount() {
    this.props.get().then((data) => {});
  }

  componentDidMount() {
    // Add click listener to close dropdowns when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Remove click listener
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    // Close all dropdowns if clicking outside
    if (!event.target.closest('.dropdown')) {
      this.setState({ openDropdowns: {} });
    }
  };

  updateuser = (id, update) => {
    this.props.update(id, update).then((data) => {
      this.props.get().then();
    });
  };

  toggleDropdown = (rowId, buttonElement) => {
    this.setState(prevState => {
      const newButtonPositions = { ...prevState.buttonPositions };
      
      // Store button position for positioning dropdown
      if (buttonElement) {
        const rect = buttonElement.getBoundingClientRect();
        newButtonPositions[rowId] = {
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX
        };
      }
      
      return {
        openDropdowns: {
          ...prevState.openDropdowns,
          [rowId]: !prevState.openDropdowns[rowId]
        },
        buttonPositions: newButtonPositions
      };
    });
  };

  closeDropdown = (rowId) => {
    this.setState(prevState => ({
      openDropdowns: {
        ...prevState.openDropdowns,
        [rowId]: false
      }
    }));
  };

  renderActionsDropdown = (cellContent, row) => {
    const isOpen = this.state.openDropdowns[row._id] || false;
    
    return (
      <div className="dropdown" style={{ position: 'relative' }}>
        <button 
          className="btn btn-secondary dropdown-toggle" 
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleDropdown(row._id, e.target);
          }}
          aria-expanded={isOpen}
        >
          Acties
        </button>
        {isOpen && (
          <div className="dropdown-menu show">
            <button 
              className="dropdown-item" 
              type="button"
              onClick={() => {
                this.updateuser(row._id, { isVerified: true });
                this.closeDropdown(row._id);
              }}
            >
              E-mail Activeren
            </button>
            <button 
              className="dropdown-item" 
              type="button"
              onClick={() => {
                this.updateuser(row._id, { SmsAuth: true });
                this.closeDropdown(row._id);
              }}
            >
              SMS Activeren
            </button>
            <button 
              className="dropdown-item" 
              type="button"
              onClick={() => {
                this.updateuser(row._id, { blocked: true });
                this.closeDropdown(row._id);
              }}
            >
              Blokkeren
            </button>
            <button 
              className="dropdown-item" 
              type="button"
              onClick={() => {
                this.updateuser(row._id, { blocked: false });
                this.closeDropdown(row._id);
              }}
            >
              Deblokkeren
            </button>
            <Link 
              className="dropdown-item" 
              to={"/admin/gebruikers/" + row._id}
              onClick={() => this.closeDropdown(row._id)}
            >
              Wijzigen
            </Link>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { SearchBar } = Search;
    const getstatus = (text, status) => {
      if (status) {
        return <small className="label bg-green">{text}</small>;
      } else {
        return <small className="label bg-orange">{text}</small>;
      }
    };

    const status = (cell, row) => {
      return (
        <div>
          {getstatus("SMS", row.SmsAuth)} {getstatus("E-mail", row.isVerified)} {getstatus("Blocked", !row.blocked)}
        </div>
      );
    };

    const columns = [
      {
        dataField: "voornaam",
        text: "Voornaam",
      },
      {
        dataField: "achternaam",
        text: "Achternaam",
      },
      {
        dataField: "email",
        text: "E-mail",
      },
      {
        dataField: "role",
        text: "Role",
      },
      {
        dataField: "isVerified",
        text: "Status",
        formatter: status,
      },
      {
        text: "Acties",
        dataField: "_id",
        formatter: this.renderActionsDropdown.bind(this),
        headerStyle: (colum, colIndex) => {
          return { width: "150px" };
        },
      },
    ];
    const { gebruikers } = this.props;
    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title"> Overzicht gebruikers</h3>
          <div className="box-tools pull-right">
            <Link type="button" className="btn-primary btn btn-box-too btn-sm" to="/admin/signup">
              <i className="fa fa-plus"></i>&nbsp; Gebruiker Toevoegen
            </Link>
          </div>
        </div>
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile" />
            <ToolkitProvider
              keyField="_id"
              data={gebruikers}
              columns={columns}
              search={{
                searchFormatted: true,
              }}
            >
              {(props) => (
                <div>
                  <SearchBar placeholder="Zoeken" {...props.searchProps} />
                  <hr />
                  <BootstrapTable 
                    key={JSON.stringify(this.state.openDropdowns)}
                    wrapperClasses="table-responsive-md" 
                    pagination={paginationFactory()} 
                    {...props.baseProps} 
                    style={{ overflow: 'visible' }}
                    classes="table-dropdown-fix"
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { username: state.auth.user, gebruikers: state.gebruikers.items };
}

export default connect(mapStateToProps, { get, update })(GeruikersPage);
